module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#longform",
      toString: function () {
        return this.url;
      }
    }